export const VIEW_KIND_TABLE = 'TABLE';
export const VIEW_KIND_BOARD = 'BOARD';
export const VIEW_KIND_MATRIX = 'MATRIX';
export const VIEW_KIND_TIMELINE = 'TIMELINE';
export const VIEW_KIND_SECTION = 'SECTION';
export const VIEW_KIND_TREE = 'TREE';

export const PROPERTY_LOADING_STATE = {
	LOADING: 'LOADING',
	LOADED: 'LOADED',
	ERROR: 'ERROR',
} as const;

/**
 * List and board views in roadmaps only support view rank.
 * Project rank is not applicable as roadmaps display ideas from multiple projects
 * */
export const ROADMAP_VIEWS_WITH_RANKING: string[] = [VIEW_KIND_TABLE, VIEW_KIND_BOARD];

export const CONNECTIONS_LAYOUT_SUMMARY = 'SUMMARY';
export const CONNECTIONS_LAYOUT_LIST = 'LIST';
export const CONNECTIONS_LAYOUT_CARDS = 'CARDS';

export const COLUMN_SIZE_DEFAULT = 'DEFAULT';
export const COLUMN_SIZE_SMALL = 'SMALL';
export const COLUMN_SIZE_LARGE = 'LARGE';

export const COLOR_STYLE_HIGHLIGHT = 'HIGHLIGHT';
export const COLOR_STYLE_BACKGROUND = 'BACKGROUND';
